export default "__VITE_ASSET__n2Z539$Q__"